import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import MediaComparisionDetail from './MediaComparisionDetail';

class MediaTripleComparisionPersona extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  resize = (arr, newSize, defaultValue) => {
    const newArray = arr;
    while (newSize > arr.length) arr.push(defaultValue);
    newArray.length = newSize;
  }

  fill(brandsOrMedia) {
    if (brandsOrMedia.length < 10) {
      this.resize(brandsOrMedia, 10, {
        brandCategory: 'N/A',
        brandLabel: 'N/A',
        icon: 'clear-field-icon_190-190-190.png',
        index: 'N/A',
        weighted: 'N/A',
        sample: 'N/A',
        pct: 'N/A',
      });
    }
    return brandsOrMedia;
  }

  render() {
    let mediaTripleCompData = [];
    if (this.props.media !== undefined) {
      mediaTripleCompData = this.props.media;
    }

    return (
      <div className="row fullwidth mediaCardPdf">
        <div className="row fullwidth demographic-detail-columns mediaTriplePersonaPdf">
          {!_.isEmpty(mediaTripleCompData) &&
            mediaTripleCompData.length > 0 &&
            mediaTripleCompData.map((media, index) => (<div key={index}>
              <div className="columns large-4 medium-4 small-4">
                {this.fill(media.brandList.slice(0, 10)).map(
                  (brandDetail, i) => (<div
                    className="row fullwidth demographic-detail-columns"
                    key={`media-t${index}${i}`}
                  >
                    <div className="columns large-12 small-12 medium-12">
                        <MediaComparisionDetail
                          key={i}
                          brandCategory={brandDetail.brandCategory}
                          statement={brandDetail.brandLabel}
                          brandDetail={brandDetail}
                          personaIndex={index}
                          selectedTab={this.props.selectedTab}
                          selectedIcon={_.camelCase(
                            brandDetail.icon.replace('.png', ''),
                          )}
                        />
                    </div>
                  </div>
                  ),
                )}
              </div>
            </div>
            )
            )}
        </div>
      </div>
    );
  }
}

MediaTripleComparisionPersona.propTypes = {
  media: PropTypes.arrayOf(PropTypes.object),
  selectedTab: PropTypes.string,
};

export default connect(
  null,
  null,
  null,
  { forwardRef: true },
)(MediaTripleComparisionPersona);
